import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Heading, TitleAdditional } from '../Elements';

import classes from './TableTitle.module.scss';

const TableTitle = ({
  title,
  additional,
  className,
  withWordResult = true
}) => {
  const { t } = useTranslation(['activity']);

  return (
    <div className={cn(classes.title, className)}>
      <Heading size={2} weight="m">
        {title && `${title} `}
        {withWordResult &&
          (additional || additional === 0) &&
          t('activity:common.RESULTS')}
      </Heading>
      {(additional || additional === 0) && (
        <TitleAdditional data={additional} />
      )}
    </div>
  );
};

TableTitle.propTypes = {
  title: PropTypes.string,
  additional: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  withWordResult: PropTypes.bool
};

export default TableTitle;
